(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const rootSelector = '[data-sm-contact]';
  const controlSelector = '[data-sm-control]';
  const initialized = new WeakSet();

  function initialize(root) {
    const form = root.querySelector('.sm-contact__form');
    if (!form || initialized.has(form)) return;
    const fields = Array.from(form.querySelectorAll('[data-sm-field]'));
    if (!fields.length) return; // Shopify has displayed a successful submission.
    initialized.add(form);
    const summary = form.querySelector('[data-sm-summary]');
    const requiredMessage = root.dataset.smRequiredMessage || 'Please complete this field.';
    const summaryMessage = root.dataset.smSummaryMessage || 'Please check the highlighted fields and try again.';
    const whitespaceErrors = new WeakSet();
    const edited = new WeakSet();
    let attempted = false;
    let invalidTask = null;

    function controls(field) {
      return Array.from(field.querySelectorAll(controlSelector));
    }
    function normalizeWhitespace(control) {
      // Clear ONLY a custom error set by this script, not an app's custom error.
      if (whitespaceErrors.has(control)) {
        control.setCustomValidity('');
        whitespaceErrors.delete(control);
      }
      if (control.required && !control.validity.customError && control.matches('input[type="text"], input[type="tel"], textarea') && control.value.length && !control.value.trim()) {
        control.setCustomValidity(requiredMessage);
        whitespaceErrors.add(control);
      }
    }
    function invalidControl(field) {
      return controls(field).find(control => {
        normalizeWhitespace(control);
        return control.willValidate && !control.validity.valid;
      });
    }
    function description(control, id, include) {
      const ids = new Set((control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      if (include) ids.add(id); else ids.delete(id);
      if (ids.size) control.setAttribute('aria-describedby', Array.from(ids).join(' '));
      else control.removeAttribute('aria-describedby');
    }
    function displayField(field) {
      const error = field.querySelector('[data-sm-error]');
      const invalid = invalidControl(field);
      // Keep a Shopify server error visible until its field is edited.
      const serverError = error && error.hasAttribute('data-sm-server-error');
      const show = Boolean(invalid || serverError);
      if (error) {
        if (!serverError) error.textContent = invalid ? (invalid.validationMessage || requiredMessage) : '';
        error.hidden = !show;
      }
      controls(field).forEach(control => {
        const marked = show && !control.disabled;
        control.classList.toggle('has-errors', marked);
        if (marked) control.setAttribute('aria-invalid', 'true');
        else control.removeAttribute('aria-invalid');
        if (error) description(control, error.id, marked);
      });
      return invalid;
    }
    function hideSummary() {
      if (summary) { summary.hidden = true; summary.textContent = ''; }
    }
    function showSummary(message) {
      if (summary) { summary.textContent = message; summary.hidden = false; }
    }
    function validateAll(focus) {
      let first = null;
      fields.forEach(field => {
        const invalid = displayField(field);
        if (!first && invalid) first = invalid;
      });
      if (first) {
        showSummary(summaryMessage);
        if (focus) first.focus();
      } else {
        hideSummary();
      }
      return !first;
    }
    function update(event) {
      const control = event.target;
      if (!(control instanceof HTMLElement) || !control.matches(controlSelector)) return;
      const field = control.closest('[data-sm-field]');
      if (!field) return;
      edited.add(control);
      const error = field.querySelector('[data-sm-error]');
      if (error) error.removeAttribute('data-sm-server-error');
      normalizeWhitespace(control);
      if (attempted || control.getAttribute('aria-invalid') === 'true') displayField(field);
      if (attempted && fields.every(item => !invalidControl(item))) hideSummary();
    }

    // Do NOT set novalidate. The browser still protects submissions if JS fails.
    // Native invalid events precede submit; listening only to submit misses them.
    form.addEventListener('invalid', event => {
      if (!event.target.matches(controlSelector)) return;
      event.preventDefault(); // Replace the tooltip with the linked inline message.
      attempted = true;
      if (invalidTask === null) {
        invalidTask = window.setTimeout(() => {
          invalidTask = null;
          if (form.isConnected) validateAll(true);
        }, 0);
      }
    }, true);
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('focusout', event => {
      const control = event.target;
      if (!(control instanceof HTMLElement) || !control.matches(controlSelector)) return;
      const field = control.closest('[data-sm-field]');
      if (field && (attempted || edited.has(control))) displayField(field);
    });
    form.addEventListener('submit', event => {
      attempted = true;
      if (!validateAll(true)) { event.preventDefault(); return; }
      const honeypot = form.querySelector('[data-sm-honeypot]');
      if (honeypot && honeypot.value.trim()) {
        event.preventDefault();
        // Permit a human to retry after accidental autofill; never fake success.
        honeypot.value = '';
        showSummary(root.dataset.smRetryMessage || 'Your message has not been sent. Please press the send button again.');
        if (summary) summary.focus();
      }
      // A valid request follows Shopify's normal submission / CAPTCHA flow.
      // No fetch, form.submit(), success simulation, disabled button, or storage.
    });
    form.addEventListener('reset', () => {
      window.setTimeout(() => {
        attempted = false;
        hideSummary();
        fields.forEach(field => {
          const error = field.querySelector('[data-sm-error]');
          controls(field).forEach(control => {
            edited.delete(control);
            if (whitespaceErrors.has(control)) { control.setCustomValidity(''); whitespaceErrors.delete(control); }
            const serverError = Boolean(error && error.hasAttribute('data-sm-server-error'));
            control.classList.toggle('has-errors', serverError);
            if (serverError) control.setAttribute('aria-invalid', 'true'); else control.removeAttribute('aria-invalid');
            if (error) description(control, error.id, serverError);
          });
          if (error && !error.hasAttribute('data-sm-server-error')) { error.hidden = true; error.textContent = ''; }
        });
      }, 0);
    });
  }
  function scan(scope) {
    if (scope instanceof Element && scope.matches(rootSelector)) initialize(scope);
    scope.querySelectorAll(rootSelector).forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
